/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 0R7aXYvaG7Fy

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicSpinnerIcon.module.css"; // plasmic-import: 0R7aXYvaG7Fy/css

import Icon79Icon from "./icons/PlasmicIcon__Icon79"; // plasmic-import: GGIAzoTRWmN9/icon

createPlasmicElementProxy;

export type PlasmicSpinnerIcon__VariantMembers = {
  light: "light";
  disabled: "disabled";
};
export type PlasmicSpinnerIcon__VariantsArgs = {
  light?: SingleBooleanChoiceArg<"light">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
};
type VariantPropType = keyof PlasmicSpinnerIcon__VariantsArgs;
export const PlasmicSpinnerIcon__VariantProps = new Array<VariantPropType>(
  "light",
  "disabled"
);

export type PlasmicSpinnerIcon__ArgsType = {};
type ArgPropType = keyof PlasmicSpinnerIcon__ArgsType;
export const PlasmicSpinnerIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicSpinnerIcon__OverridesType = {
  root?: Flex__<"div">;
  spinnerIcon?: Flex__<typeof PlasmicImg__>;
  spinnerIcon2?: Flex__<typeof PlasmicImg__>;
  spinnerIcon3?: Flex__<"svg">;
};

export interface DefaultSpinnerIconProps {
  light?: SingleBooleanChoiceArg<"light">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSpinnerIcon__RenderFunc(props: {
  variants: PlasmicSpinnerIcon__VariantsArgs;
  args: PlasmicSpinnerIcon__ArgsType;
  overrides: PlasmicSpinnerIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "light",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.light
      },
      {
        path: "disabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.disabled
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootdisabled]: hasVariant($state, "disabled", "disabled") }
      )}
    >
      {(
        hasVariant($state, "disabled", "disabled")
          ? true
          : hasVariant($state, "light", "light")
            ? false
            : true
      ) ? (
        <PlasmicImg__
          data-plasmic-name={"spinnerIcon"}
          data-plasmic-override={overrides.spinnerIcon}
          alt={""}
          className={classNames(
            sty.spinnerIcon,
            "myevals-react-frontend__spinner",
            {
              [sty.spinnerIcondisabled]: hasVariant(
                $state,
                "disabled",
                "disabled"
              ),
              [sty.spinnerIconlight]: hasVariant($state, "light", "light")
            }
          )}
          displayHeight={"auto"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"none"}
          displayMinWidth={"0"}
          displayWidth={"auto"}
          loader={"plasmic"}
          loading={"eager"}
          src={{
            src: "https://site-assets.plasmic.app/8198fb2ac32c0f09dbead75422b33bd6.svg",
            fullWidth: 32,
            fullHeight: 32,
            aspectRatio: 1
          }}
        />
      ) : null}
      {(hasVariant($state, "light", "light") ? true : false) ? (
        <PlasmicImg__
          data-plasmic-name={"spinnerIcon2"}
          data-plasmic-override={overrides.spinnerIcon2}
          alt={""}
          className={classNames(
            sty.spinnerIcon2,
            "myevals-react-frontend__spinner",
            {
              [sty.spinnerIcon2disabled]: hasVariant(
                $state,
                "disabled",
                "disabled"
              ),
              [sty.spinnerIcon2light]: hasVariant($state, "light", "light")
            }
          )}
          displayHeight={"auto"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"none"}
          displayMinWidth={"0"}
          displayWidth={"auto"}
          loader={"plasmic"}
          loading={"eager"}
          src={{
            src: "https://site-assets.plasmic.app/db8c58faaf14c166911226e91f68d478.svg",
            fullWidth: 32,
            fullHeight: 32,
            aspectRatio: 1
          }}
        />
      ) : null}
      <Icon79Icon
        data-plasmic-name={"spinnerIcon3"}
        data-plasmic-override={overrides.spinnerIcon3}
        className={classNames(
          projectcss.all,
          sty.spinnerIcon3,
          "myevals-react-frontend__spinner",
          {
            [sty.spinnerIcon3disabled]: hasVariant(
              $state,
              "disabled",
              "disabled"
            )
          }
        )}
        role={"img"}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "spinnerIcon", "spinnerIcon2", "spinnerIcon3"],
  spinnerIcon: ["spinnerIcon"],
  spinnerIcon2: ["spinnerIcon2"],
  spinnerIcon3: ["spinnerIcon3"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  spinnerIcon: typeof PlasmicImg__;
  spinnerIcon2: typeof PlasmicImg__;
  spinnerIcon3: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSpinnerIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSpinnerIcon__VariantsArgs;
    args?: PlasmicSpinnerIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSpinnerIcon__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSpinnerIcon__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSpinnerIcon__ArgProps,
          internalVariantPropNames: PlasmicSpinnerIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSpinnerIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSpinnerIcon";
  } else {
    func.displayName = `PlasmicSpinnerIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicSpinnerIcon = Object.assign(
  // Top-level PlasmicSpinnerIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    spinnerIcon: makeNodeComponent("spinnerIcon"),
    spinnerIcon2: makeNodeComponent("spinnerIcon2"),
    spinnerIcon3: makeNodeComponent("spinnerIcon3"),

    // Metadata about props expected for PlasmicSpinnerIcon
    internalVariantProps: PlasmicSpinnerIcon__VariantProps,
    internalArgProps: PlasmicSpinnerIcon__ArgProps
  }
);

export default PlasmicSpinnerIcon;
/* prettier-ignore-end */
